/*console.log("LIFETIME!!", lifetimeDataPath)

if (lifetimeDataPath) {
    getLifeTimeData(lifetimeDataPath)
}*/



document.querySelectorAll(".aktuar-lifetime-calculator").forEach(element => {
    const form = document.querySelector(".lifetime-calculator-form")
    const ageInput = document.getElementById("age-input");
    const ageRangeInput = document.getElementById("age-range");
    const resetButtons = document.querySelectorAll(".calculator-reset");
    const min = ageRangeInput.min;
    const max = ageRangeInput.max;

    ageRangeInput.addEventListener("input", () => {
        ageInput.value = ageRangeInput.value;
        updateRangeGradient(element,ageRangeInput.value,min,max)
    })
    ageInput.addEventListener("input", () => {
        ageRangeInput.value = ageInput.value;
        updateRangeGradient(element,ageInput.value,min,max)
    })
    resetButtons.forEach(button => {
        button.addEventListener("click", () => {
            ageInput.value = 45;
            ageRangeInput.value = 45;
            updateRangeGradient(element,ageInput.value,min,max)
            if (element.querySelector(".gender-radio input[type='radio']:checked")) {
                element.querySelector(".gender-radio input[type='radio']:checked").checked = false;
            }
            element.classList.remove("show-result")
            element.classList.remove("female")
            element.scrollIntoView({behavior: "smooth", block: "start"})
        })
    })
    form.addEventListener("submit", async (e) => {
        e.preventDefault()
        if (!lifetimeDataPath) {
            console.error("no lifetime data path")
            return
        }
        const formData = new FormData(form)
        const lifeTimeData =  await getLifeTimeData(lifetimeDataPath)
        const age = formData.get("age")
        const gender = formData.get("gender")
        const lifeTime = lifeTimeData[gender][age]
        const displayLifetime = document.getElementById("result-avg")
        const displayLifetime80 = document.getElementById("result-80")
        const displayLifetime50 = document.getElementById("result-50")
        const displayLifetime20 = document.getElementById("result-20")
        const displayCurrentAge = document.getElementById("current-age")

        displayLifetime.innerHTML = Math.round(lifeTime.avg).toLocaleString();
        displayLifetime80.innerHTML = lifeTime.p80.toLocaleString();
        displayLifetime50.innerHTML = lifeTime.p50.toLocaleString();
        displayLifetime20.innerHTML = lifeTime.p20.toLocaleString();


        displayCurrentAge.innerHTML = age;

        if (gender === "w") {
            element.classList.add("female")
        }

        element.classList.add("loading")
        element.scrollIntoView({behavior: "smooth", block: "center"})
        setTimeout(() => {
            element.classList.remove("loading")
            element.classList.add("show-result")
            element.scrollIntoView({behavior: "smooth", block: "start"})
        }, 2000)


    })
})


async function getLifeTimeData(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const result = await response.json();
        return result
    } catch (error) {
        console.error(error.message);
    }
}

function updateRangeGradient(element,age,min,max) {
    const percent = Math.round((age - min) / (max - min) * 100);
    element.style.setProperty("--range-percent", percent+"%");
}

function isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') >= 0;
}